module.exports = __webpack_public_path__ + "static/media/map-picker.8429be5b.svg";